import request from '@/utils/request'

// 创建预约会议
export function createMeeting(data) {
  return request({
    url: '/yuzhen/meeting/create',
    method: 'post',
    data: data
  })
}

// 创建预约会议
export function createMeetingQuick(data) {
  return request({
    url: '/yuzhen/meeting/quick',
    method: 'post',
    data: data
  })
}

// 更新预约会议
export function updateMeeting(data) {
  return request({
    url: '/yuzhen/meeting/update',
    method: 'put',
    data: data
  })
}

// 删除预约会议
export function deleteMeeting(id) {
  return request({
    url: '/yuzhen/meeting/delete?id=' + id,
    method: 'delete'
  })
}

// 获得预约会议
export function getMeeting(id) {
  return request({
    url: '/yuzhen/meeting/get?id=' + id,
    method: 'get'
  })
}

// 获得预约会议
export function getMeetingPermitAll(id) {
  return request({
    url: '/yuzhen/meeting/permit/get?id=' + id,
    method: 'get'
  })
}

// 获得预约会议分页
export function getMeetingPage(query) {
  return request({
    url: '/yuzhen/meeting/page',
    method: 'post',
    data: query
  })
}

// 获得预约会议分页
export function getAllMeetingFuture() {
  return request({
    url: '/yuzhen/meeting/all/future',
    method: 'get',
  })
}


// 获得历史会议信息
export function getHistoryMeeting(query) {
  return request({
    url: '/yuzhen/meeting/history',
    method: 'post',
    data: query
  })
}


// 导出预约会议 Excel
export function exportMeetingExcel(query) {
  return request({
    url: '/yuzhen/meeting/export-excel',
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}

// 取消预约会议
export function cancelMeeting(id) {
  return request({
    url: '/yuzhen/meeting/cancel?id=' + id,
    method: 'get'
  })
}

// 会议资源占用情况
export function countPexipOccupy(query) {
  return request({
    url: '/yuzhen/meeting/occupy',
    method: 'post',
    data: query
  })
}
